<div class="flex flex-wrap justify-start lg:justify-end gap-4">
  <p-datepicker
    [(ngModel)]="rangeDates"
    selectionMode="range"
    clearButtonStyleClass="bg-red right-4 ml-6 text-red"
    [inputStyle]="{
      border: 'none',
      paddingLeft: '0',
      paddingRight: '0'
    }"
    [styleClass]="
      'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 border-gray-300 focus:border-[#1f273b]'
    "
    (onSelect)="onDateChange()"
    (onClear)="onDateChange()"
    placeholder="Search by date"
    showClear="true"
  ></p-datepicker>
 <div class="relative w-full mt-3 sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingIdInput"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"
    inputmode="numeric"
    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch()"
    class="border-b text-sm border-gray-400 focus:outline-none
           focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />

  <span
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
    class="
      absolute left-0 top-full mt-1
      text-red-600 text-xs
      z-50
      max-w-[220px]
      break-words
      leading-tight
    "
  >
    Filing ID must be an integer.
  </span>
</div>

  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerNameInput"
    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
    placeholder="Search by issuer name"
    type="text"
  />

  <select
    (change)="onSearch()"
    [(ngModel)]="selectedFormType"
    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  >
    <option [ngValue]="null">Select form type</option>
    <option *ngFor="let type of formTypes" [ngValue]="type">
      {{ type }}
    </option>
  </select>
</div>
<div class="mb-4"></div>
<p-table
  [value]="filingRecords"
  [paginator]="true"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Filing Id</th>
      <th>Filing Type</th>
      <th>Accession Number</th>
      <th>Issuer Name</th>
      <th>Source URL</th>
      <th>analyst</th>
      <th>discard Reason</th>
      <th>Restore</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-filing>
    <tr>
      <td>
        {{ filing.filingId }}
      </td>
      <td>{{ filing.filingType }}</td>
      <td>{{ filing.accessionNumber }}</td>
      <td>{{ filing.companyName }}</td>
      <td>
        <a href="{{ filing.xbUrl }}" *ngIf="filing.xbUrl" target="_blank"
          >Link</a
        >

        <span *ngIf="!filing.xbUrl">-</span>
      </td>
      <td>{{ filing.updatedBy }}</td>
      <td>{{ filing.discardReason }}</td>
      <td>
        <button
          pButton
          type="button"
          icon="pi pi-replay"
          class="p-button-text p-button-success"
          (click)="restoreFiling(filing)"
          pTooltip="Restore filing"
          tooltipPosition="top"
        ></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
